<div class="common-modal">
  <div class="modal-header">
    <div class="header-container">

      <div class="title-wrapper">
          @if (config.iconClass) {
            <i class="icon" [class]="config.iconClass"></i>
          }
          <h2 class="title" [title]="config.header">{{ config.header }}</h2>
      </div>

      <app-ag-action-icon-button
        iconClass="ic-close-20"
        (action)="close()"
      />
    </div>
  </div>

  @if (config.body) {
    <div class="modal-body" [innerHtml]="config.body"></div>
  }

  <div class="modal-footer">
    @for (action of config.actions; track action) {
      <app-button
        [btnColor]="action.btnColor ?? 'orange'"
        [text]="action.text"
        [iconClass]="action?.iconClass ?? ''"
        [isDisabled]="isLoading()"
        (clickBtn)="performAction(action.action)"
      />
    }

    @if (config.showCloseBtn ?? false) {
      <div [class]="config.closeBtnWrapperClass ?? ''">
        <app-button
          btnColor="white"
          [text]="config.closeBtnText ?? 'Close'"
          [isDisabled]="isLoading()"
          (clickBtn)="cancel()"
        />
      </div>
    }
  </div>
</div>
